import React from "react";
import Password from "../../UI/Password";

const GameSettingUpdateModal = ({
  rowData,
  updateAll,
  handleShowHide,
  handleFn,
}) => {
  console.log("rowDatasunil", rowData);
  return (
    <>
      <div className="heading_market heading_market--subpage">
        <div className="content_text">
          <h2 className="content_text__eyebrow d-flex align-items-center gap-1 flex-wrap">
            <span className="menu-text text-primary">
              {rowData?.marketTypeName}
            </span>
          </h2>
        </div>
      </div>

      <Password
        onCancel={handleShowHide}
        onConfirm={() => handleFn(rowData, updateAll)}
      />
    </>
  );
};

export default GameSettingUpdateModal;
